import { Radio, FlaskConical } from "lucide-react";

export const SimuladoBadge = ({ liveMode, className = "" }) => {
  if (liveMode) {
    return (
      <span
        data-testid="live-mode-badge"
        className={`inline-flex items-center gap-1.5 rounded-full border border-emerald-300 bg-emerald-50 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wider text-emerald-700 ${className}`}
      >
        <Radio className="h-3 w-3" /> Modo Real
      </span>
    );
  }
  return (
    <span
      data-testid="simulado-badge"
      title="Las cifras de reproducciones y regalías aparecen cuando llegan los primeros reportes reales de las tiendas"
      className={`inline-flex items-center gap-1.5 rounded-full border border-amber-400 bg-amber-100 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wider text-amber-800 ${className}`}
    >
      <FlaskConical className="h-3 w-3" /> Datos de tiendas pronto
    </span>
  );
};
